import dayjs from "dayjs";
export var formatDate = function (rawDate) {
    if (rawDate) {
        var date = new Date(rawDate);
        if (date < new Date(0)) {
            return '';
        }
        return new Intl.DateTimeFormat("en-GB", { dateStyle: 'short', timeStyle: 'short' }).format(date);
    }
    return '';
};
export var formatDateYearMonth = function (rawDate) {
    if (rawDate) {
        var date = new Date(rawDate);
        if (date < new Date(0)) {
            return '';
        }
        return dayjs(date).format('MMMM/YYYY');
    }
    return '';
};
export var formatDateWithSecond = function (rawDate) {
    if (rawDate) {
        var date = new Date(rawDate);
        if (date < new Date(0)) {
            return '';
        }
        return new Intl.DateTimeFormat("en-GB", { dateStyle: 'short', timeStyle: 'medium' }).format(date);
    }
    return '';
};
export var formatDateWithoutTime = function (rawDate) {
    if (rawDate) {
        var date = new Date(rawDate);
        if (date < new Date(0)) {
            return '';
        }
        return dayjs(date).format('DD/MM/YYYY');
    }
    return '';
};
